import { PiGlobe, PiBaby, PiDog, PiLeaf, PiWheelchair, PiHeart, PiBuilding, PiUserCircleGear, PiHandshake, PiQuestion } from "react-icons/pi";

export const categoryIcons = {
  "지구촌": PiGlobe,
  "아동•청소년": PiBaby,
  "동물": PiDog,
  "환경": PiLeaf,
  "장애인": PiWheelchair,
  "가족•여성": PiHeart,
  "시민사회": PiBuilding,
  "어르신": PiUserCircleGear,
  "다문화": PiHandshake,
  "기타": PiQuestion
};